/**
 * Object of all valid empty state types
 *
 * @enum {string}
 */
export const AppletEmptyStateType = {
    INCOMPATIBLE: 'INCOMPATIBLE',
    NO_DATA: 'NO_DATA',
    NO_DOCUMENTS: 'NO_DOCUMENTS',
    NO_SEARCH: 'NO_SEARCH',
    PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    REPORTS: 'REPORTS',
    QUERY_TOO_COMPLEX: 'QUERY_TOO_COMPLEX',
    SEARCH_TIMEOUT: 'SEARCH_TIMEOUT',
    UNCONFIGURED: 'UNCONFIGURED'
};

/**
 * Return whether or not a string is a valid AppletEmptyStateType
 *
 * @param {string} type String to validate
 * @returns {boolean} true if valid, false if invalid
 */
export function isValidAppletEmptyState(type) {
    return AppletEmptyStateType.hasOwnProperty(type);
}

Object.freeze(AppletEmptyStateType);
